var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoSolidTwoDotted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 184",
    width: 8,
    height: 184,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2 Solid 2 Dotted Lines-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #121212 } \n\t\t.s2 { fill: #040404 } \n\t\t.s3 { fill: #050505 } \n\t\t.s4 { fill: #8a8a8a } \n\t\t.s5 { fill: #8b8b8b } \n\t\t.s6 { fill: #3b3b3b } \n\t\t.s7 { fill: #3a3a3a } \n\t\t.s8 { fill: #393939 } \n\t\t.s9 { fill: #353535 } \n\t\t.s10 { fill: #313131 } \n\t\t.s11 { fill: #323232 } \n\t\t.s12 { fill: #383838 } \n\t\t.s13 { fill: #272727 } \n\t\t.s14 { fill: #262626 } \n\t\t.s15 { fill: #242424 } \n\t\t.s16 { fill: #252525 } \n\t\t.s17 { fill: #333333 } \n\t\t.s18 { fill: #303030 } \n\t\t.s19 { fill: #2f2f2f } \n\t\t.s20 { fill: #373737 } \n\t\t.s21 { fill: #2c2c2c } \n\t\t.s22 { fill: #2b2b2b } \n\t\t.s23 { fill: #2e2e2e } \n\t\t.s24 { fill: #2d2d2d } \n\t\t.s25 { fill: #232323 } \n\t\t.s26 { fill: #202020 } \n\t\t.s27 { fill: #1f1f1f } \n\t\t.s28 { fill: #1e1e1e } \n\t\t.s29 { fill: #111111 } \n\t\t.s30 { fill: #101010 } \n\t\t.s31 { fill: #0f0f0f } \n\t\t.s32 { fill: #0e0e0e } \n\t\t.s33 { fill: #0d0d0d } \n\t\t.s34 { fill: #0c0c0c } \n\t\t.s35 { fill: #1b1b1b } \n\t\t.s36 { fill: #1a1a1a } \n\t\t.s37 { fill: #181818 } \n\t\t.s38 { fill: #171717 } \n\t\t.s39 { fill: #191919 } \n\t\t.s40 { fill: #0a0a0a } \n\t\t.s41 { fill: #0b0b0b } \n\t\t.s42 { fill: #1c1c1c } \n\t\t.s43 { fill: #1d1d1d } \n\t\t.s44 { fill: #080808 } \n\t\t.s45 { fill: #070707 } \n\t\t.s46 { fill: #060606 } \n\t\t.s47 { fill: #090909 } \n\t\t.s48 { fill: #141414 } \n\t\t.s49 { fill: #151515 } \n\t\t.s50 { fill: #131313 } \n\t\t.s51 { fill: #161616 } \n\t\t.s52 { fill: #535353 } \n\t\t.s53 { fill: #4d4d4d } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-506 552.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-506 506.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-506 368.7c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-506 322.7c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-506 184.8c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-506 138.9c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-506 1c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s0",
    d: "m-497 139c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m364.5 92.7q2.2 0 4.5 0 0 0.7 0 1.5-1 0-2.1 0-0.3 0-0.6 0-0.8 0-1.5 0-0.1-0.2-0.3-0.3 0-0.6 0-1.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m205.6 92.7q2.2 0 4.5 0 0 0.7 0 1.5-1.1 0-2.1 0-0.3 0-0.6 0-0.8 0-1.6 0-0.1-0.2-0.2-0.3 0-0.6 0-1.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m23.9 92.7q2.2 0 4.5 0 0 0.7 0 1.5-1.1 0-2.1 0-0.3 0-0.7 0-0.7 0-1.5 0-0.1-0.2-0.2-0.3 0-0.6 0-1.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-135.1 92.7q2.2 0 4.5 0 0 0.7 0 1.5-1 0-2.1 0-0.3 0-0.6 0-0.8 0-1.5 0-0.2-0.2-0.3-0.3 0-0.6 0-1.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m235.8 460.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-294.1 460.3q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-385 460.3q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m235.8 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-74.6 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-233.6 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-294.1 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-385 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s9",
    d: "m266.1 47q2.2 0 4.5 0 0 0.6 0 1.2-2.3 0-4.5 0 0-0.6 0-1.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m129.8 47q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-29.1 47q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-51.9 47q2.3 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-188.1 47q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-210.8 47q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-362.3 47q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-385 47q2.2 0 4.5 0 0 0.6 0 1.2-2.2 0-4.5 0 0-0.6 0-1.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m387.3 460.3q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m357 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m334.3 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m288.8 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m228.3 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m198.1 460.3q2.1 0 4.2 0 0.1 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m175.3 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m152.6 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m107.1 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m76.9 460.3q2 0 4.2 0 0.1 0.6 0.3 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m46.6 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-74.6 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-97.1 460.3q2.1 0 4.2 0 0 0.6 0 1.3-2.2 0-4.5 0 0.2-0.6 0.3-1.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-112.3 460.3q2 0 4.2 0 0.1 0.6 0.3 1.3-2.3 0-4.5 0 0-0.6 0-1.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "s12",
    d: "m-233.6 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-256.1 460.3q2.1 0 4.3 0 0 0.6 0 1.3-2.2 0-4.5 0 0.1-0.6 0.2-1.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-263.8 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-271.3 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-422.8 460.3q2.1 0 4.3 0 0.1 0.6 0.2 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-453 460.3q2.1 0 4.2 0 0.2 0.6 0.3 1.3-2.2 0-4.5 0 0-0.6 0-1.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m387.3 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m334.3 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m228.3 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m175.3 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m152.6 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m46.6 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-6.4 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-97.4 230.8q2.3 0 4.5 0 0 0.6 0 1.2-2 0-4.2 0-0.1-0.6-0.3-1.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-112.3 230.8q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "s13",
    d: "m-256.3 230.8q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-271.3 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-294.1 230.8q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-316.8 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-453 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-475.8 230.8q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-498.5 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m394.8 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m319 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m296.3 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m213.1 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m160.1 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m137.3 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m114.6 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m84.4 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m76.9 92.9q2.2 0 4.5 0-0.2 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m54.1 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m1.1 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-21.6 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-44.4 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-97.4 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-104.9 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-180.6 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.2 0-0.2-0.6-0.3-1.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-203.3 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-256.3 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-263.8 92.9q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-286.6 92.9q2.3 0 4.5 0 0 0.6 0 1.3-2 0-4.2 0-0.1-0.6-0.3-1.3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m-422.8 92.9q2.2 0 4.5 0-0.1 0.6-0.2 1.3-2.1 0-4.3 0 0-0.6 0-1.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m-445.5 92.9q2.2 0 4.5 0 0 0.6 0 1.3-2.1 0-4.3 0-0.1-0.6-0.2-1.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "s8",
    d: "m-453 92.9q2.2 0 4.5 0-0.1 0.6-0.3 1.3-2.1 0-4.2 0 0-0.6 0-1.3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m387.3 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m334.3 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m296.3 47q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m235.8 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m228.3 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m175.3 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m152.6 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m137.3 47q2.3 0 4.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.1-0.6-0.3-1.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m114.6 47q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m76.9 47q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m46.6 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-21.6 47q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-44.4 47q2.3 0 4.5 0 0 0.6 0 1.2-2.1 0-4.2 0-0.1-0.6-0.3-1.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-97.4 47q2.3 0 4.5 0 0 0.6 0 1.2-2 0-4.2 0-0.1-0.6-0.3-1.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-112.3 47q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-203.3 47q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "s11",
    d: "m-256.3 47q2.2 0 4.5 0 0 0.6 0 1.2-2.1 0-4.3 0-0.1-0.6-0.2-1.2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-263.8 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-271.3 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-294.1 47q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-316.8 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-339.5 47q2.2 0 4.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "s17",
    d: "m-422.8 47q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "s10",
    d: "m-453 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-475.8 47q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-498.5 47q2.2 0 4.5 0-0.1 0.6-0.3 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m319 230.8q2.3 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.1-0.6-0.3-1.2z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m160.1 230.8q2.2 0 4.5 0-0.1 0.6-0.3 1.2-1.9 0-4 0-0.1-0.6-0.2-1.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "s14",
    d: "m1.1 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.1-0.6-0.3-1.2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-180.6 230.8q2.2 0 4.5 0-0.1 0.6-0.2 1.2-2 0-4 0-0.2-0.6-0.3-1.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-82.1 460.3q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "s20",
    d: "m-82.1 92.9q2.1 0 4.2 0 0 0.6 0 1.3-2 0-4.2 0 0-0.6 0-1.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m281.3 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m122.3 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m61.9 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m39.1 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-119.8 47q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-142.6 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-218.3 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-278.8 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-301.6 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-324.3 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-369.8 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-377.3 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "s21",
    d: "m-460.5 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "s22",
    d: "m-483.3 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m379.8 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m357 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m273.8 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m258.6 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m251.1 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m220.8 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m198.1 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m99.6 47q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m92.1 47q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m69.4 47q2 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-59.4 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-66.9 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-89.6 47q2.1 0 4.2 0 0 0.6 0 1.2-2 0-4.2 0 0-0.6 0-1.2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "s19",
    d: "m-225.8 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-241.1 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "s18",
    d: "m-248.6 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "s23",
    d: "m-392.5 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-400 47q2.1 0 4.2 0 0 0.6 0 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "s24",
    d: "m-437.8 47q2.1 0 4.3 0 0 0.6 0 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "s15",
    d: "m-415.3 230.8q2.1 0 4.3 0 0 0.6 0 1.2-2 0-4 0-0.1-0.6-0.3-1.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m84.4 460.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m39.1 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m16.4 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-6.4 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-51.9 460.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-142.6 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-165.3 460.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-210.8 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-316.8 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-339.5 460.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-362.3 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "s16",
    d: "m-415.3 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-475.8 460.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-498.5 460.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m387.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m364.5 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m341.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m319 414.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m296.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m288.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m235.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m228.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m205.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m182.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m160.1 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m137.3 414.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "s31",
    d: "m107.1 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m84.4 414.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m76.9 414.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m46.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m23.9 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m1.1 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-21.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-74.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-97.4 414.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-112.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-135.1 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-157.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-180.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-203.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-233.6 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-256.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-263.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-271.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-294.1 414.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-316.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-339.5 414.6q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-362.3 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-385 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-422.8 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "s32",
    d: "m-475.8 414.6q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-498.5 414.6q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m84.4 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.3 0-4.5 0 0-0.4 0-0.9z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-97.4 276.8q2.3 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-256.3 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-294.1 276.8q2.3 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-316.8 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-339.5 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.3 0-4.5 0 0-0.4 0-0.9z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-362.3 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-453 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-475.8 276.8q2.3 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-498.5 276.8q2.2 0 4.5 0 0 0.4 0 0.9-2.2 0-4.5 0 0-0.4 0-0.9z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-339.5 230.8q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-362.3 230.8q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m387.3 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m228.3 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m46.6 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-112.3 92.9q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "s25",
    d: "m-271.3 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-316.8 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-339.5 92.9q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-362.3 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "s26",
    d: "m-475.8 92.9q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "s27",
    d: "m-498.5 92.9q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m319 47q2.3 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m160.1 47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m16.4 47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m1.1 47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-6.4 47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-165.3 47q2.2 0 4.5 0 0 0.5 0 1-2.3 0-4.5 0 0-0.5 0-1z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-180.6 47q2.2 0 4.5 0 0 0.5 0 1-2.2 0-4.5 0 0-0.5 0-1z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m379.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m220.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m402.5 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m395 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m364.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m349.5 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m342 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m326.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m319.3 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m311.5 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m304 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m296.5 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m273.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m266.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m258.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m251.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m243.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m213.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m205.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m183.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m167.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m160.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m145.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m137.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m129.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m114.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m99.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m92.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m69.4 460.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m54.4 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m24.1 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m8.9 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m1.4 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-13.9 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-21.4 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-29.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-36.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-44.1 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-59.4 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-66.9 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-89.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-104.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-134.8 460.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-150.1 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-157.6 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-172.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-180.3 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-188.1 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-195.6 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-203.1 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-225.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-241.1 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-248.6 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-286.3 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-324.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-331.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-347 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-354.5 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-369.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-392.5 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-400 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-407.5 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-437.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-445.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-483.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-490.8 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-506 460.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m372.3 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m281.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m190.6 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m122.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m61.9 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m31.6 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-119.8 460.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-127.3 460.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-218.3 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-278.8 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-301.6 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-309 460.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-377.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-430.3 460.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-460.5 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-468 460.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m402.5 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m395 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m379.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m372.3 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m357 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m349.5 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m334.3 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m326.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m311.5 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m304 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m281.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m273.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m266.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m258.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m251.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m243.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m220.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m213.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m198.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m190.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m175.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m167.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m152.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m145.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m129.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m122.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m114.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m99.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m92.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m69.4 414.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m61.9 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m54.4 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m39.1 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m31.6 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m16.4 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m8.9 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-6.4 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-13.9 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-29.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-36.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-44.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-51.9 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-59.4 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-66.9 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-82.1 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-89.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-104.6 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-119.8 414.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-127.3 414.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-142.6 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-150.1 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-165.3 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-172.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-188.1 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-195.6 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-210.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-218.3 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-225.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-241.1 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "s34",
    d: "m-248.6 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-278.8 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-286.3 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-301.6 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-309 414.6q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-324.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-331.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-347 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-354.5 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-369.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-377.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-392.5 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-400 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-407.5 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "s33",
    d: "m-415.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-430.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-437.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-445.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-453 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-460.5 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-468 414.6q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-483.3 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-490.8 414.6q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-506 414.6q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m114.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-44.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m349.5 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m326.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m304 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m167.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m145.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m129.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m16.4 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m8.9 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-6.4 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-13.9 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-29.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-36.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-150.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-165.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-172.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-188.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-195.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-324.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-331.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-347 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-354.5 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-369.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-483.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-490.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-506 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m402.5 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m395 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m387.5 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m379.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m372.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m357 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m342 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m334.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m319.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m311.5 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m296.5 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m281.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m273.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m258.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m251.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m243.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m228.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m220.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m213.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m198.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m190.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m183.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m175.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m160.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m152.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m137.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m122.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m107.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m99.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m92.1 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m77.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m69.4 276.8q2 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m61.9 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m54.4 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m46.9 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m39.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m31.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m1.4 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-21.4 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-51.9 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-59.4 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-66.9 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-74.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-89.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-104.6 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-112.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-119.8 276.8q2 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-127.3 276.8q2 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-142.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m-157.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-180.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-203.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-210.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-218.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-225.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-233.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-241.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m-248.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-263.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-271.1 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-278.8 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-286.3 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2 0-4.2 0 0-0.4 0-0.9z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-301.6 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-309 276.8q2 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-377.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-384.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-392.5 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-400 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-407.5 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-415.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-422.5 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-430.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-437.8 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-445.3 276.8q2.1 0 4.3 0 0 0.4 0 0.9-2.1 0-4.3 0 0-0.4 0-0.9z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-460.5 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m-468 276.8q2.1 0 4.2 0 0 0.4 0 0.9-2.1 0-4.2 0 0-0.4 0-0.9z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m402.5 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m395 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m379.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m372.3 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m364.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m357 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m349.5 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m342 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m326.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m311.5 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m304 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m296.5 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m281.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m273.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m258.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m251.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m243.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m236.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m220.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m213.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m205.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m198.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m190.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m183.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m167.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m145.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m137.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m129.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m122.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m114.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m107.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m99.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m92.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m84.4 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m77.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m69.4 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m61.9 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m54.4 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m39.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m31.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m24.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m16.4 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m8.9 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-13.9 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-21.4 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-29.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-36.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-44.1 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-51.9 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-59.4 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-66.9 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-74.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-89.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-104.6 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-119.8 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-127.3 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-134.8 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-142.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-150.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "s44",
    d: "m-157.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-165.3 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-172.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-188.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-195.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-203.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-210.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-218.3 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "s47",
    d: "m-225.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-233.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-241.1 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "s40",
    d: "m-248.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-263.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-278.8 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-286.3 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-301.6 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-309 230.8q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-324.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-331.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-347 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-354.5 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-369.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-377.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-384.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-392.5 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-400 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-407.5 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-422.5 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-430.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "s46",
    d: "m-437.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "s45",
    d: "m-445.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-460.5 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-468 230.8q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-483.3 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-490.8 230.8q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-506 230.8q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m372.3 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m281.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m190.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m122.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m61.9 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m31.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-51.9 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-119.8 92.9q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-127.3 92.9q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-210.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-218.3 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-278.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-301.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-309 92.9q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-377.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-430.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-460.5 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "s39",
    d: "m-468 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m402.5 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m357 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m349.5 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m342 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m334.3 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m326.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m311.5 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m304 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m288.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m266.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m251.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m243.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m198.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m183.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m175.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m167.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m152.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m145.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m129.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m107.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m69.4 92.9q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m39.1 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m16.4 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m8.9 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-6.4 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-13.9 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-29.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-36.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-89.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-142.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-150.1 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-157.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-165.3 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-172.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-188.1 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-195.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "s43",
    d: "m-248.6 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-324.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-331.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-347 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-354.5 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-369.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-392.5 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "s28",
    d: "m-415.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-483.3 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-490.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-506 92.9q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m379.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m273.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m258.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m220.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m99.6 92.9q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m92.1 92.9q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-59.4 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-66.9 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "s42",
    d: "m-225.8 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-241.1 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-400 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "s35",
    d: "m-407.5 92.9q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "s36",
    d: "m-437.8 92.9q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m372.3 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m349.5 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m304 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m190.6 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m167.8 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m145.1 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m31.6 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m8.9 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-36.6 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-127.3 47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-150.1 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-195.6 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-309 47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-331.8 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-354.5 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-430.3 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "s50",
    d: "m-468 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-490.8 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m402.5 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m395 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m364.8 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m342 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m326.8 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m311.5 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m288.8 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m243.6 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "s48",
    d: "m213.3 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m205.8 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m183.1 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m107.1 47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m84.4 47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m54.4 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m24.1 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-13.9 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-74.6 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-104.6 47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "s38",
    d: "m-134.8 47q2 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "s51",
    d: "m-157.6 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-172.8 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-233.6 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-286.3 47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-347 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-407.5 47q2.1 0 4.2 0 0 0.5 0 1-2.1 0-4.2 0 0-0.5 0-1z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "s37",
    d: "m-415.3 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "s49",
    d: "m-445.3 47q2.1 0 4.3 0 0 0.5 0 1-2.1 0-4.3 0 0-0.5 0-1z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-506 47q2.1 0 4.2 0 0 0.5 0 1-2 0-4.2 0 0-0.5 0-1z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m364.8 276.8q2 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m289.1 276.8q1.9 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "s29",
    d: "m266.3 276.8q2 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m236.1 276.8q1.9 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m205.8 276.8q2 0 4 0 0 0.4 0 0.9-1.9 0-4 0 0-0.4 0-0.9z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m24.1 276.8q2 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-81.9 276.8q2 0 4 0 0 0.4 0 0.9-1.9 0-4 0 0-0.4 0-0.9z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "s30",
    d: "m-134.8 276.8q1.9 0 4 0 0 0.4 0 0.9-2 0-4 0 0-0.4 0-0.9z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m289.1 230.8q1.9 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m266.3 230.8q2 0 4 0 0 0.5 0 1-2 0-4 0 0-0.5 0-1z"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-81.9 230.8q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-81.9 47q2 0 4 0 0 0.5 0 1-1.9 0-4 0 0-0.5 0-1z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m364.8 93.2q2 0 4 0 0 0.3 0 0.7-2 0-4 0 0-0.4 0-0.7z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m205.8 93.2q2 0 4 0 0 0.3 0 0.7-1.9 0-4 0 0-0.4 0-0.7z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m24.1 93.2q2 0 4 0 0 0.3 0 0.7-2 0-4 0 0-0.4 0-0.7z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "s41",
    d: "m-134.8 93.2q1.9 0 4 0 0 0.3 0 0.7-2 0-4 0 0-0.4 0-0.7z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m387.3 230.8q0.1 0.4 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m228.3 230.8q0.1 0.4 0.3 0.7 1.8 0 3.7 0 0-0.3 0-0.7 0.3 0 0.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m46.6 230.8q0.1 0.4 0.3 0.7 1.8 0 3.7 0 0-0.3 0-0.7 0.3 0 0.5 0-0.1 0.6-0.2 1.2-2.1 0-4.3 0 0-0.6 0-1.2z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-112.3 230.8q0.1 0.4 0.2 0.7 1.8 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.2 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "s52",
    d: "m-271.3 230.8q0.1 0.4 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "s53",
    d: "m-453 230.8q0.1 0.4 0.2 0.7 1.9 0 3.8 0 0-0.3 0-0.7 0.2 0 0.5 0-0.1 0.6-0.3 1.2-2.1 0-4.2 0 0-0.6 0-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoSolidTwoDotted);
export default __webpack_public_path__ + "static/media/twoSolidTwoDotted.7bfa5871abef0b100b01472752ea4e1b.svg";
export { ForwardRef as ReactComponent };